/* ====================================================================
   FLOOREVER — DRAWER PANIER (sections/floorever-drawer.liquid)
   Vanilla JS, defer, aucune dépendance. Section statique rendue sur
   toutes les pages (layout/theme.liquid).

   - Clic sur l'icône panier du header (.cart-link) : contenu rafraîchi
     (Section Rendering API) puis ouverture. SANS JS : lien -> /cart.
   - CustomEvent 'floorever:cart:change' (contrat commun, émis par la
     fiche, la page échantillon, les cartes, la page panier) : contenu
     rafraîchi, ouverture AUTO seulement si item_count AUGMENTE (un
     ajout — jamais sur un retrait) et jamais pour les sources 'drawer'
     et 'panier' (sources normalisées par assets/floorever-cart.js).
   - « Retirer » par ligne : /cart/change.js quantity 0, corps re-rendu
     par Liquid (réponse `sections`), pastille header + événement émis
     (detail.source = 'drawer' -> la page panier se re-rend si ouverte).
   - Fermeture : Échap natif (<dialog>), bouton, clic sur le fond
     (cible === dialog, même précédent que le zoom PDP). Scroll lock :
     attribut scroll-lock géré par le Skeleton (critical.css).

   Seul [data-drawer-body] est remplacé — jamais le <dialog> lui-même
   (sinon l'état open serait perdu). Rendu 100 % Liquid, zéro template JS.

   AUDIT PANIER 16/10/2026 : le re-rendu (?sections=) se fait SANS en-tête
   Accept: application/json — avec cet en-tête, Shopify renvoie le JSON
   de la ressource (produit, collection, page, panier) et ignore
   `sections` : le drawer s'ouvrait avec un contenu périmé partout sauf
   sur l'accueil. Après un retrait : focus rendu à la ligne suivante (ou
   au premier lien du drawer vide) et annonce dans [data-drawer-statut].
   ==================================================================== */
(function () {
  'use strict';

  var DRAWER_ID = 'floorever-drawer';

  function init() {
    var dialog = document.querySelector('[data-drawer]');
    if (!dialog || dialog.dataset.drawerInit === 'true') return;
    if (typeof dialog.showModal !== 'function') return; /* très vieux navigateurs : lien /cart */
    dialog.dataset.drawerInit = 'true';

    var route = (dialog.dataset.routeCartChange || '/cart/change') + '.js';
    var dernierCompte = parseInt(dialog.dataset.count, 10) || 0;
    var enCours = false;

    function majPastille(compte) {
      if (window.FloorEverCart) { window.FloorEverCart.majPastille(compte); return; }
      var lien = document.querySelector('.cart-link');
      if (!lien) return;
      var compteur = lien.querySelector('.cart-count');
      if (!compteur && compte > 0) {
        compteur = document.createElement('span');
        compteur.className = 'cart-count';
        compteur.setAttribute('aria-hidden', 'true');
        lien.appendChild(compteur);
      }
      if (compteur) {
        if (compte > 0) compteur.textContent = compte;
        else compteur.remove();
      }
      lien.setAttribute('aria-label', compte === 0 ? 'Panier vide' : 'Panier, ' + compte + ' article' + (compte > 1 ? 's' : ''));
    }

    /* Injecte le HTML re-rendu du drawer (corps + compteurs). */
    function injecter(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nouveau = doc.querySelector('[data-drawer-body]');
      var corps = dialog.querySelector('[data-drawer-body]');
      if (nouveau && corps) corps.innerHTML = nouveau.innerHTML;
      var compte = doc.querySelector('[data-drawer-count]');
      var compteCourant = dialog.querySelector('[data-drawer-count]');
      if (compte && compteCourant) compteCourant.textContent = compte.textContent;
      var dial = doc.querySelector('[data-drawer]');
      if (dial) dialog.dataset.count = dial.dataset.count;
    }

    /* Re-rendu serveur du drawer seul. PAS d'en-tête Accept JSON : sur une
       URL de ressource, Shopify renverrait le JSON de la ressource. */
    function rafraichir() {
      return fetch(window.location.pathname + '?sections=' + DRAWER_ID)
        .then(function (r) {
          if (!r.ok) throw new Error('re-rendu impossible (' + r.status + ')');
          return r.json();
        })
        .then(function (sections) {
          if (sections && sections[DRAWER_ID]) injecter(sections[DRAWER_ID]);
        })
        .catch(function () { /* on ouvrira avec le contenu courant */ });
    }

    /* Annonce polie (lecteurs d'écran) : vider puis écrire pour que deux
       messages identiques successifs soient bien relus. */
    function annoncer(msg) {
      var statut = dialog.querySelector('[data-drawer-statut]');
      if (!statut) return;
      statut.textContent = '';
      window.setTimeout(function () { statut.textContent = msg; }, 60);
    }

    /* Après un retrait : focus sur le « Retirer » de la ligne qui a pris
       la place (ou la dernière), sinon le premier lien du drawer vide,
       sinon le bouton de fermeture. */
    function focusApresRetrait(index) {
      var boutons = dialog.querySelectorAll('[data-drawer-remove]');
      var cible = boutons[Math.min(index, boutons.length - 1)] ||
        dialog.querySelector('.drawer-vide a') ||
        dialog.querySelector('[data-drawer-close]');
      if (cible) cible.focus({ preventScroll: true });
    }

    function ouvrir() {
      rafraichir().then(function () {
        if (!dialog.open) dialog.showModal();
      });
    }

    /* Icône panier du header -> drawer (repli no-JS : navigation /cart). */
    document.querySelectorAll('.cart-link').forEach(function (lien) {
      lien.addEventListener('click', function (e) {
        if (window.location.pathname === (lien.getAttribute('href') || '/cart')) return;
        e.preventDefault();
        ouvrir();
      });
    });

    /* Fermetures : bouton, clic sur le fond (cible = dialog). Échap natif. */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) { dialog.close(); return; }
      if (e.target.closest('[data-drawer-close]')) { dialog.close(); return; }
      if (e.target.closest('[data-drawer-close-nav]')) { dialog.close(); return; }

      var retirer = e.target.closest('[data-drawer-remove]');
      if (retirer && !enCours) {
        enCours = true;
        var indexRetire = Array.prototype.indexOf.call(
          dialog.querySelectorAll('[data-drawer-remove]'), retirer
        );
        retirer.setAttribute('aria-busy', 'true');
        fetch(route, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          /* Par clé de ligne, pas par index : un panier modifié ailleurs
             ne fait jamais retirer un autre produit. */
          body: JSON.stringify({
            id: retirer.dataset.key,
            quantity: 0,
            sections: DRAWER_ID
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('retrait impossible (' + r.status + ')');
            return r.json();
          })
          .then(function (panier) {
            if (panier.sections && panier.sections[DRAWER_ID]) injecter(panier.sections[DRAWER_ID]);
            dernierCompte = panier.item_count;
            majPastille(panier.item_count);
            focusApresRetrait(Math.max(indexRetire, 0));
            var st = dialog.querySelector('[data-drawer-subtotal]');
            annoncer(
              panier.item_count === 0
                ? 'Article retiré. Votre panier est vide.'
                : 'Article retiré.' + (st ? ' Sous-total : ' + st.textContent.trim() + '.' : '')
            );
            document.dispatchEvent(
              new CustomEvent('floorever:cart:change', {
                detail: { cart: panier, source: 'drawer' }
              })
            );
          })
          .catch(function () {
            annoncer('Le retrait a échoué. Réessayez dans un instant.');
            rafraichir().then(function () { focusApresRetrait(Math.max(indexRetire, 0)); });
          })
          .finally(function () { enCours = false; });
      }
    });

    /* Mutations venues des autres surfaces : rafraîchir, et n'OUVRIR que
       sur un ajout (le compteur augmente). */
    document.addEventListener('floorever:cart:change', function (e) {
      var d = e.detail || {};
      if (d.source === 'drawer') return;
      var n = d.cart && typeof d.cart.item_count === 'number' ? d.cart.item_count : null;
      var ajout = n !== null && n > dernierCompte;
      if (n !== null) dernierCompte = n;
      /* Jamais d'ouverture automatique depuis la page panier : son
         compteur augmente à chaque « + » de quantité (audit T4). */
      if (ajout && d.source !== 'panier') ouvrir();
      else rafraichir();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
